import { Trash } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, purgeGroupPosts } from './groupOpsApi'

/**
 * A4.25 — Ommaviy postni o'chirish. Chatdagi postlarni ommaviy o'chiradi.
 * JONLI `/admin/groups` ro'yxati; mutatsiya endpoint chiqqach jonli.
 */
export function GroupPurgePosts() {
  return (
    <GroupActionList
      screenId="A4.25"
      title={S.purgePosts}
      description={S.purgeNote}
      actionId="purge"
      actionLabel={S.purgePosts}
      actionIcon={<Trash size={13} />}
      emptyIcon={<Trash size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      danger
      successMsg={S.purged}
      run={async (r) => {
        const reason = (window.prompt(S.purgeReason) ?? '').trim()
        if (!reason) return false
        if (!window.confirm(S.purgeConfirm)) return false
        await purgeGroupPosts(r.id, reason)
        return true
      }}
    />
  )
}
